export default {
  dynamics: '{{change}} vs previous week',
};
